import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vocabulary-library" }
const _hoisted_2 = { class: "container-fluid px-3 px-sm-4" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 vocabulary-library__inner" }
const _hoisted_5 = { class: "row g-4 g-md-4 g-lg-5 vocabulary-library__grid" }

import { reactive } from "vue";
import { useRouter } from "vue-router";
import BookCard from "@/components/BookCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'VocabularyLibrary',
  setup(__props) {

const router = useRouter();

const books = reactive([
  {
    id: "eviu",
    title: "English Vocabulary in Use",
    description: "یادگیری واژگان روزمره انگلیسی در متن واقعی.",
    level: "متوسط تا پیشرفته",
    units: "۱۰۰ واحد",
    progress: 62,
    coverColor: "blue",
    coverTitle: "English\nVocabulary\nin Use",
    logo: "📘 Cambridge",
    publisher: "CambridgePress",
  },
  {
    id: "ielts-vocab",
    title: "Vocabulary for IELTS",
    description: "واژگان ضروری آکادمیک برای موفقیت در آیلتس.",
    level: "آکادمیک",
    units: "۲۵ فصل",
    progress: 18,
    coverColor: "purple",
    coverTitle: "Vocabulary\nfor\nIELTS",
    logo: "📗 Academic",
    publisher: "Academic",
  },
]);

function handleContinue(_book: { id: string; title: string }) {
  router.push("/dashboard/leitner");
}

function goBack() {
  const hasHistory = window.history.state && window.history.state.back;
  if (hasHistory) {
    router.back();
  } else {
    router.push("/dashboard");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "vocabulary-library__back",
            "aria-label": "بازگشت به صفحه تمرین آیلتس",
            onClick: goBack
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "20",
              height: "20",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", {
                d: "M5 12H19",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              _createElementVNode("path", {
                d: "M13 6l6 6-6 6",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1),
            _createElementVNode("span", null, "بازگشت", -1)
          ]))]),
          _cache[1] || (_cache[1] = _createElementVNode("header", { class: "vocabulary-library__header" }, [
            _createElementVNode("p", { class: "vocabulary-library__eyebrow" }, "کتابخانه واژگان"),
            _createElementVNode("h1", { class: "vocabulary-library__title" }, "منبع یادگیری‌ات رو انتخاب کن"),
            _createElementVNode("p", { class: "vocabulary-library__subtitle" }, " یکی از کتاب‌ها رو انتخاب کن تا مسیر واژگان شروع بشه. ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books, (book) => {
              return (_openBlock(), _createElementBlock("div", {
                key: book.id,
                class: "col-12 col-md-6"
              }, [
                _createVNode(BookCard, {
                  title: book.title,
                  description: book.description,
                  level: book.level,
                  units: book.units,
                  progress: book.progress,
                  "cover-color": book.coverColor,
                  "cover-title": book.coverTitle,
                  logo: book.logo,
                  publisher: book.publisher,
                  onContinue: ($event: any) => (handleContinue(book))
                }, null, 8, ["title", "description", "level", "units", "progress", "cover-color", "cover-title", "logo", "publisher", "onContinue"])
              ]))
            }), 128))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("footer", {
            class: "vocabulary-library__footer",
            role: "note"
          }, [
            _createElementVNode("span", {
              class: "vocabulary-library__footer-icon",
              "aria-hidden": "true"
            }, "💡"),
            _createElementVNode("span", null, "هر زمان خواستی می‌تونی بین منابع جابه‌جا بشی.")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})